import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink, Button } from 'reactstrap';
import moment from 'moment';
import { CommunityRepository, getCommunityTopic, EventSubscriberRepository, SubscriptionLevels } from '@amityco/js-sdk';
import * as queryString from 'query-string';
import * as types from '../../constants/prayerFeatureActionTypes';
import * as consts from '../../constants/prayerFeatureConstants';
import InputForm from './InputForm';
import PrayerCard from './PrayerCard';
import InfoModal from '../common/InfoModal';
import Spinner from '../common/spinner';
import StatusBanner from '../common/StatusBanner';
import ConfirmationToast from '../common/ConfirmationToast';
import MiniSpinner from "../common/MiniSpinner";
import BackdropWrapper from '../common/BackdropWrapper';
import QualtricsClickToLaunch from "../dashboard/voiceOfCustomer/QualtricsClickToLaunch";
import * as tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

let _activeTab = '1';
let _sessionStartTime = null;
let _sendSessionStartTime = true;
let _livePrayers = null;
let _liveMyPrayers = null
let _postEventsWired = false;
let _communityTopic = null;
let _myPrayersCount = 0;

function PrayerWall({
    featureAmity, memberId, token, connectionState, activeTab, hasError, myRecentPrayerPostId, loadingMore, history,
    onEnteringPrayerWall, onLeavingPrayerWall, setupSession, updateUserRole, setActiveTab,
    allPrayers, myPrayers, getAllPrayers, getMyPrayers, getNextPrayers, refreshAllPrayers, refreshMyPrayers, updateAllPrayers, updateMyPrayers,
    getNotificationBadge, showBadge, markNotificationBadgeAsRead, updatePreference, getDeletedPosts, markDeletedPostsAsRead
}) {
    const [activeTabBeforeRequest, setActiveTabBeforeRequest] = useState('1');
    const [editingPrayer, setEditingPrayer] = useState(null);
    const [toastMessage, setToastMessage] = useState('');
    const [showInfo, setShowInfo] = useState(false);
    const [showMiniSpinner, setShowMiniSpinner] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const [showNewPost, setShowNewPost] = useState(false);
    const [showPrayerCardTooltip, setShowPrayerCardTooltip] = useState(false);
    const [showPrayerWallTooltip, setShowPrayerWallTooltip] = useState(false);
    const [showDeleteMsg, setShowDeleteMsg] = useState(false);
    const [deletedTime, setDeletedTime] = useState('');
    const [deletedReason, setDeletedReason] = useState('');
    const [showAdminDeleteMsg, setShowAdminDeleteMsg] = useState(false);
    const [showArchivedDeleteMsg, setShowArchivedDeleteMsg] = useState(false);
    const [scrollY, setScrollY] = useState({ '1': 0, '2': 0, '3': 0 });
    const referenceToNextPage = React.useRef(null);
    const prayerTooltipMsg = <>
        <p>The All Posts tab is a place where you have access to all posts submitted by the community. You can see updates from the author or a Baylor Scott & White Health Chaplain and show your support by tapping the heart icon.</p>
        <p>The My Posts tab will show only your submitted posts so you can quickly see any new activity.</p>
    </>;
    const infoTime = <>Monday - Friday | 7am - 7pm | <a href="tel:254.724.1575" className="phone-link">254.724.1575</a></>;
    let timerHandle = null;
    const toolTipInfo = <><p>Now that you have submitted your first post, there are a couple of things you should know.</p> <p>You can click "..." on the card to reveal more options like edit or remove. You can also add updates underneath your post and view responses from Chaplains. Additionally, see how many individuals have shown support for your post by viewing the heart in the lower left hand corner of your card.</p></>
    //client.on('dataError', error => {
    //    console.log('amity client.on DataError', error);
    //    if (error.code === ErrorCode.GlobalBanError) {
    //        setIsFailed(isFailed);
    //        setToastMessage('It looks like you have used a word in your update that violates our terms. Please remove the word to post on our Prayer Wall.');
    //    }
    //});

    const hideMiniSpinner = () => {
        if (showMiniSpinner) {
            setShowMiniSpinner(false);
        }
    }

    const handleScroll = (e) => {
        const livePrayers = _activeTab === '1' ? _livePrayers : _activeTab === '2' ? _liveMyPrayers : null;
        if (livePrayers && livePrayers.hasMore) {
            const bottom =
                e.target.scrollingElement.scrollHeight -
                e.target.scrollingElement.scrollTop -
                20 <=
                e.target.scrollingElement.clientHeight;
            if (bottom) {
                setShowMiniSpinner(true);
                getNextPrayers((gotMore, error) => {
                    if (error) {
                        onActionComplete({ confirmationMessage: consts.LOAD_MORE_POST_ERROR }, error !== null)
                    } else if (gotMore) {
                        scrollDown();
                    } else {
                        //window.scrollBy(0, -20);
                    }
                });
            }
        }
        else {
            setShowMiniSpinner(false);
        }
        if (_activeTab === '1' && window.scrollY <= 200) {
            setShowNewPost(false);
        }
    };

    const scrollDown = () => {
        if (typeof window !== 'undefined') {
            let count = 0;
            var timerHandle = setInterval(() => {
                if (count++ < 20 && window.scrollY < document.body.clientHeight - 1400) {
                    window.scrollBy(0, 10);
                }
                else {
                    clearInterval(timerHandle);
                }
            }, 22);
        }
    };

    const _getDeletedPosts = () => {
        getDeletedPosts(response => {
            if (response) {
                if (response.activityType == 'Delete') {
                    setShowAdminDeleteMsg(true);
                    const deletedTime = moment(response.postDate).format('MMMM Do');
                    setDeletedTime(deletedTime);
                    const deleteReason = response.reason;
                    setDeletedReason(deleteReason);
                }
                else if (response.activityType == 'Archive') {
                    setShowArchivedDeleteMsg(true);
                }
            }
        });
    };

    const loadPosts = () => {
        getAllPrayers(livePrayers => {
            if (livePrayers) {
                livePrayers.on('dataUpdated', prayers => {
                    if (!referenceToNextPage.current) {
                        _livePrayers = livePrayers;
                        updateAllPrayers(prayers, livePrayers, _sendSessionStartTime ? _sessionStartTime : null, gotNewPost => {
                            logUI('MBHWeb.PrayerWall.' + types.GET_ALL_PRAYERS_SUCCESS, _sendSessionStartTime ? _sessionStartTime : new Date(), tools.getURLPath(), { count: prayers ? prayers.length : 0 }, memberId);
                            if (gotNewPost && window.scrollY > 200) {
                                setShowNewPost(true);
                            }
                            hideMiniSpinner();
                        });
                        _sendSessionStartTime = false;
                    }
                });
                livePrayers.on('dataError', error => {
                    console.log('getAllPrayers', error);
                    hideMiniSpinner();
                });
                _postEventsWired = true;
            }
        });
        getMyPrayers(memberId, livePrayers => {
            if (livePrayers) {
                livePrayers.on('dataUpdated', prayers => {
                    _liveMyPrayers = livePrayers;
                    updateMyPrayers(prayers, livePrayers);
                    if (_myPrayersCount > prayers.length) {
                        setTimeout(() => _getDeletedPosts(), 1000);
                    }
                    _myPrayersCount = prayers.length;
                    logUI('MBHWeb.PrayerWall.' + types.GET_MY_PRAYERS_SUCCESS, new Date(), tools.getURLPath(), { count: prayers ? prayers.length : 0 }, memberId);
                    hideMiniSpinner();
                });
                livePrayers.on('dataError', error => {
                    console.log('getMyPrayers', error);
                    hideMiniSpinner();
                });
            }
        });
    };

    const refresh = (tab) => {
        if (_postEventsWired) {
            if (tab === '1') {
                refreshAllPrayers();
            }
            else if (tab === '2') {
                refreshMyPrayers();
            }
            else {
                refreshAllPrayers();
                refreshMyPrayers();
            }
        }
        else {
            loadPosts();
        }
    };

    useEffect(() => {
        if (loadingMore !== undefined && !loadingMore) {
            setShowMiniSpinner(loadingMore);
        }
    }, [loadingMore]);

    useEffect(() => {
        const searchParams = location.search ? queryString.parse(location.search)
            : location.searchParms ? queryString.parse(location.searchParms) : null;
        switch (searchParams && searchParams['tab'].toLowerCase()) {
            case 'myposts':
                if (searchParams['target'] === memberId) {
                    setActiveTab('2', memberId);
                }
                else {
                    history.push('/');
                }
                break;
            case 'addpost':
                setActiveTab('3', memberId);
                break;
        }

        window.addEventListener('scroll', handleScroll);
        if (_sessionStartTime === null) {
            _sessionStartTime = moment();
            onEnteringPrayerWall(_sessionStartTime);
            logUI('MBHWeb.PrayerWall.' + types.PRAYER_WALL_ENTERED, new Date(), tools.getURLPath(), null, memberId, _sessionStartTime);
        }
        if (featureAmity) {
            setupSession(featureAmity.memberId, token, (response, error) => {
                loadPosts();
                getNotificationBadge();
                _getDeletedPosts();
                const liveObject = CommunityRepository.communityForId(window.serverData.data.amityCommunityId);
                liveObject.once('dataUpdated', community => {
                    if (community && community.communityId) {
                        _communityTopic = getCommunityTopic(community, SubscriptionLevels.POST_AND_COMMENT);
                        if (_communityTopic) {
                            EventSubscriberRepository.subscribe(_communityTopic, response => {
                                console.log('subcribing with community topic', response);
                                loadPosts();
                            });
                        }
                    }
                    liveObject.dispose();
                });

                if (response && response.currentUser) {
                    response.currentUser.on('dataUpdated', user => {
                        const userRole = user.roles.length !== 0 ? user.roles[0] : 'user';
                        updateUserRole(userRole);
                        logUI('MBHWeb.PrayerWall.' + types.UPDATE_AMITY_USER_ROLE, new Date(), tools.getURLPath(), { userRole }, memberId);
                    });
                }
                if (response && response[consts.HIDE_PRAYER_WALL_TOOLTIP] !== undefined && !response[consts.HIDE_PRAYER_WALL_TOOLTIP]) {
                    setShowPrayerWallTooltip(true);
                }
                //client.on('connectionStatusChanged', ({ oldValue, newValue }) => {
                //    console.log('amityConnectionChanged', oldValue, newValue);
                //    setConnectionState(newValue);
                //    if (newValue === 'connected') {
                //        loadPosts();
                //    }
                //    else if (newValue === 'disconnected') {
                //    }
                //});
                if (!timerHandle) {
                    timerHandle = window.setInterval(refresh, 1000 * window.serverData.data.prayersRefreshIntervalInSeconds);
                }
            });
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (timerHandle) {
                window.clearInterval(timerHandle);
                timerHandle = null;
            }
            let sessionDurationInMinutes = null;
            if (_sessionStartTime) {
                sessionDurationInMinutes = moment.duration(moment().diff(_sessionStartTime)).asMinutes().toFixed(2);
            }
            onLeavingPrayerWall(sessionDurationInMinutes);
            logUI('MBHWeb.PrayerWall.' + types.PRAYER_WALL_LEFT, new Date(), tools.getURLPath(), null, memberId, sessionDurationInMinutes);
            if (_communityTopic) {
                EventSubscriberRepository.unsubscribe(_communityTopic);
            }
        };
    }, []);

    useEffect(() => {
        scrollToLatest();
    }, [myRecentPrayerPostId]);

    useEffect(() => {
        window.scrollTo(0, scrollY[activeTab]);
        _activeTab = activeTab;
        if (showBadge && activeTab === "2") {
            markNotificationBadgeAsRead();
        }
    }, [activeTab]);

    const saveScrollY = () => {
        scrollY[activeTab] = window.scrollY;
        setScrollY(scrollY);
    };
    const switchPrayers = tab => {
        saveScrollY();
        setActiveTab(tab, memberId);
        refresh(tab);
        if (tab === activeTab) {
            scrollToTop();
        }
    };

    const prayerHeader = () => {
        return (
            <div className="col-12">
                <div className="card">
                    <div className="align-items-center d-flex justify-content-between chaplain-message">
                        <div>Chaplains are here to listen.</div>
                        <Link to={{ pathname: '/communitySupport' }} onClick={() => { setShowInfo(true) }}>Learn More</Link>
                    </div>
                </div>
            </div>
        );
    };

    const prayerDeleteMsg = () => {
        return (
            <div className="col-12">
                <div className="card">
                    <div className="align-items-center d-flex justify-content-between delete-message">
                        <div>Your post has been deleted.</div>
                        <Link className="link" to={{ pathname: '/communitySupport' }} onClick={() => { setShowDeleteMsg(true) }}>View Message</Link>
                    </div>
                </div>
            </div>
        );
    };

    const prayerArchivedDeleteMsg = () => {
        return (
            <div className="col-12">
                <div className="card">
                    <div className="align-items-center d-flex justify-content-between archived-delete-message">
                        <div>One or more of your posts was deleted. Our community deletes posts after 30 days due to inactivity.</div>
                        <button className="btn btn-icon-only" onClick={() => { setShowArchivedDeleteMsg(false); markNotificationBadgeAsRead(); markDeletedPostsAsRead() }}><span className="icon-close" /></button>
                    </div>
                </div>
            </div>
        );
    };

    const renderRequestButton = (position, text, onClick) => {
        return (
            <Button className={`prayer-request-button ${position} ml-auto mr-auto`} onClick={onClick}>{text}</Button>
        );
    };

    const scrollToTop = () => {
        if (typeof window !== 'undefined') {
            var timerHandle = setInterval(() => {
                if (document.body.scrollTop != 0 || document.documentElement.scrollTop != 0)
                    window.scrollBy(0, -50); else clearInterval(timerHandle);
            }, 10);

        }
    };

    const scrollToLatest = () => {
        let recentPrayer = document.getElementById(myRecentPrayerPostId);
        if (recentPrayer) {
            setTimeout(() => {
                recentPrayer.scrollIntoView({
                    block: 'center',
                    behaviour: 'smooth',
                    inline: 'center',
                }),
                    3000;
            });
        }
    };

    const switchToForm = data => {
        saveScrollY();
        if (activeTab !== '3') {
            setActiveTabBeforeRequest(activeTab);
        }
        setToastMessage('');
        setEditingPrayer(data);
        setActiveTab('3', memberId);
    };

    const onActionComplete = (data, isFailed) => {
        if (activeTab === '3') {
            setActiveTab(activeTabBeforeRequest, memberId);
            if (data && (data[consts.HIDE_PRAYER_CARD_TOOLTIP] !== undefined && !data[consts.HIDE_PRAYER_CARD_TOOLTIP])) {
                setShowPrayerCardTooltip(true);
            }
        }
        if (data) {
            setIsFailed(isFailed);
            setToastMessage(data.confirmationMessage);
        }
    };

    //const lastPrayerDate = allPrayers && allPrayers.length ? new Date(allPrayers[allPrayers.length - 1].createdAt) : null;
    //const myPrayersFiltered = lastPrayerDate && myPrayers && myPrayers.length ? myPrayers.filter(p => p.createdAt >= new Date(lastPrayerDate)) : [];
    const prayerFeatureHeader = () => {
        return (
            <>
                <div className="row prayer-header">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">Community Support</h1>
                    </div>
                </div>
                <div className="row prayers-nav">
                    <div className="col-12 prayers-nav__tabs">

                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={activeTab === '1' ? 'active' : ''}
                                            onClick={() => switchPrayers('1')}
                                        >
                                            All Posts
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            className={activeTab === '2' ? 'active' : ''}
                                            onClick={() => {
                                                switchPrayers('2');
                                                _getDeletedPosts();
                                            }}
                                        >
                                            My Posts{(showBadge || showAdminDeleteMsg || showArchivedDeleteMsg) && <div className="prayer-wall-card-red-circle" />}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className="request-button-nav ml-auto">
                                        {renderRequestButton('header-button', "ADD A POST", () => switchToForm(null))}
                                    </NavItem>
                                </Nav>
                            </div>
                        </div>

                    </div>
                    <ConfirmationToast
                        message={toastMessage}
                        isOpen={toastMessage !== ''}
                        toggle={() => setToastMessage('')}
                        isFailed={isFailed}
                        autoClose
                    />
                    {showNewPost && activeTab === '1' && window.scrollY > 200 &&
                        <div className="new-post-btn">
                            {renderRequestButton('', "new post", () => { scrollToTop(); setShowNewPost(false); })}
                        </div>
                    }
                </div>
            </>
        )
    }

    return (
        <>
            <div className={"container-fluid body-content prayerfeature-container " + (activeTab === '3' && "prayer-request-form")} >
                {!hasError || (allPrayers && allPrayers.length > 0) ? (
                    <>
                        {showPrayerWallTooltip ?
                            <BackdropWrapper
                                align="bottom"
                                toolTipHeading="Support Wall"
                                onClickBackdrop={() => { updatePreference(consts.HIDE_PRAYER_WALL_TOOLTIP, true); setShowPrayerWallTooltip(false); }}
                                toolTipInfo={prayerTooltipMsg}
                                okBtnText="OKAY, GOT IT!"
                                showTooltip={showPrayerWallTooltip}
                                wrapperClass="prayer-header-tooltip-container"
                            >
                                {prayerFeatureHeader()}
                            </BackdropWrapper> :
                            <>
                                {prayerFeatureHeader()}
                            </>
                        }
                        <InfoModal
                            alignText="center"
                            className="prayerinfo-modal"
                            hideBorder
                            isOpen={showDeleteMsg}
                            modalBody={<>
                                <p className="prayerpost-info">Your post made on<span className='delete-msg-bold'> {deletedTime} </span> has been deleted for {deletedReason}.</p>
                                <p className="prayerpost-info">{consts.DELETE_INFO_THIRD_MESSAGE}</p>
                            </>}
                            modalFooter={<>
                                <div className="prayerinfo-okay">
                                    <button
                                        type="button"
                                        className="btn text-btn"
                                        onClick={() => {
                                            setShowDeleteMsg(false)
                                            setShowAdminDeleteMsg(false)
                                            markNotificationBadgeAsRead()
                                            markDeletedPostsAsRead()
                                        }}
                                    >
                                        OKAY
                                    </button>
                                </div>
                            </>}
                        />
                        <InfoModal
                            alignText="center"
                            className="prayerinfo-modal"
                            hideBorder
                            isOpen={showInfo}
                            modalBody={<>
                                <p className="prayerpostheader-info">
                                    {consts.CHAPLAIN_INFO_HEADER}
                                </p>
                                <p className="prayerpost-info">{consts.CHAPLAIN_INFO_MESSAGE}</p>
                                <p className="prayerpost-info">{consts.CHAPLAIN_INFO_SECOND_MESSAGE}</p>
                                <p className="prayerposttime-info">
                                    <span>{consts.CHAPLAIN_INFO_FOOTER}</span><br />
                                    <span>{infoTime}</span>
                                </p>
                            </>}
                            modalFooter={<>
                                <div className="prayerinfo-okay">
                                    <button
                                        type="button"
                                        className="btn text-btn"
                                        onClick={() => {
                                            setShowInfo(false);
                                        }}
                                    >
                                        OKAY
                                    </button>
                                </div>
                            </>}
                        />
                        <div className="row prayers-container">
                            <div className="col-12 maxWidth-content dash-board-container-content">
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <div className="row prayers-heading">{prayerHeader()}</div>
                                        {allPrayers && allPrayers.length > 0 &&
                                            allPrayers.map((prayer, idx) => (
                                                <React.Fragment key={prayer.postId}>
                                                    <BackdropWrapper
                                                        key={prayer.postId}
                                                        align="bottom"
                                                        onClickBackdrop={() => { updatePreference(consts.HIDE_PRAYER_CARD_TOOLTIP, true); setShowPrayerCardTooltip(false); }}
                                                        toolTipHeading="Your Card"
                                                        toolTipInfo={toolTipInfo}
                                                        okBtnText="OKAY, GOT IT!"
                                                        scrollIntoView
                                                        showTooltip={showPrayerCardTooltip && activeTab === '1' && myRecentPrayerPostId === prayer.postId}
                                                        wrapperClass={`${(showPrayerCardTooltip && activeTab === '1' && myRecentPrayerPostId === prayer.postId) ? "prayer-toolTip-container" : ""}`}
                                                    >
                                                        <PrayerCard
                                                            key={prayer.postId}
                                                            prayer={prayer}
                                                            memberId={memberId}
                                                            onEdit={switchToForm}
                                                            onActionComplete={onActionComplete}
                                                        />
                                                    </BackdropWrapper>
                                                    {idx === 1 && <QualtricsClickToLaunch
                                                        reload={true}
                                                        class="col-12 dashboard-card--full-width"
                                                        id="bsw_qtx_click"
                                                        message="TELL US HOW WE'RE DOING"
                                                        enabled={window.serverData.data.enableQualtricsSurveyPrayerWall}
                                                    />}
                                                </React.Fragment>
                                            ))
                                        }
                                    </TabPane>

                                    <TabPane tabId="2">
                                        <div className="row prayers-heading">{prayerHeader()}</div>
                                        {showAdminDeleteMsg && <div className=" row admin-delete-banner">{prayerDeleteMsg()}</div>}
                                        {showArchivedDeleteMsg && <div className=" row admin-delete-banner">{prayerArchivedDeleteMsg()}</div>}
                                        {myPrayers && myPrayers.length > 0
                                            ? myPrayers.map(prayer => (
                                                <BackdropWrapper
                                                    key={prayer.postId}
                                                    align="bottom"
                                                    onClickBackdrop={() => { updatePreference(consts.HIDE_PRAYER_CARD_TOOLTIP, true); setShowPrayerCardTooltip(false); }}
                                                    toolTipHeading="Your Card"
                                                    toolTipInfo={toolTipInfo}
                                                    okBtnText="OKAY, GOT IT!"
                                                    scrollIntoView
                                                    showTooltip={showPrayerCardTooltip && activeTab === '2' && myRecentPrayerPostId === prayer.postId}
                                                    wrapperClass={`${(showPrayerCardTooltip && activeTab === '2' && myRecentPrayerPostId === prayer.postId) ? "prayer-toolTip-container" : ""}`}
                                                >
                                                    <PrayerCard
                                                        key={prayer.postId}
                                                        prayer={prayer}
                                                        memberId={memberId}
                                                        onEdit={switchToForm}
                                                        onActionComplete={onActionComplete}
                                                    />
                                                </BackdropWrapper>
                                            ))
                                            : <div className="row prayers-heading">
                                                <div className="col-12">
                                                    <div className="row page-title">
                                                        <div className="col-12 prayers-heading-no-prayers">
                                                            <div className="svg-prayer-hands" />
                                                            <div>{consts.NO_POST_MESSAGE}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </TabPane>

                                    <TabPane tabId="3">
                                        <div className="row prayers-heading ">
                                            <div className="col-12">
                                                <div className="row page-title">
                                                    <div className="col-12 prayers-heading-message">
                                                        <h3>{editingPrayer ? 'Edit' : 'Add a Post'}</h3>
                                                        <div>{consts.POST_DISCLAIMER}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <InputForm memberId={memberId} connectionState={connectionState} data={editingPrayer} onActionComplete={onActionComplete} />
                                    </TabPane>
                                </TabContent>
                                {showMiniSpinner &&
                                    <div className="col-12 align-self-center">
                                        <MiniSpinner />
                                    </div>
                                }
                            </div>
                        </div>
                        {activeTab < '3' && !allPrayers && !myPrayers && <Spinner />}
                        {renderRequestButton('footer-button', "ADD A POST", () => switchToForm(null))}
                    </>
                ) : (
                    <StatusBanner
                        bannerAlignment="left"
                        bannerMsg={consts.COMMUNITY_SUPPORT_IS_DOWN}
                        failedStatus
                    />
                )}
            </div>
        </>
    );
}

const mapStateToProps = state => {
    const featureAmity = state.memberships.featureAmity;
    return {
        featureAmity,
        memberId: state.prayerFeature.memberId || (featureAmity && featureAmity.memberId),
        token: state.prayerFeature.token,
        connectionState: state.prayerFeature.connectionState,
        activeTab: state.prayerFeature.activeTab,
        allPrayers: state.prayerFeature.prayers,
        myPrayers: state.prayerFeature.myPrayers,
        hasError: state.prayerFeature.error || state.prayerFeature.hasError,
        hasEditPrayerError: state.prayerFeature.hasEditPrayerError,
        livePrayers: state.prayerFeature.livePrayers,
        myRecentPrayerPostId: state.prayerFeature.myRecentPrayerPostId,
        updating: state.prayerFeature.updating || state.prayerFeature.updatingMyPrayers,
        showBadge: state.prayerFeature.showBadge,
        loadingMore: state.prayerFeature.loadingMore,
        history: state.session.history,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setupSession: (memberId, token, callback) => {
            dispatch({ type: types.SETUP_AMITY_USER_SESSION, memberId, token, callback });
        },
        setConnectionState: connectionState => dispatch({ type: types.AMITY_CONNECTION_CHANGED, connectionState }),
        updateUserRole: userRole => dispatch({ type: types.UPDATE_AMITY_USER_ROLE, userRole }),
        setActiveTab: (activeTab, memberId) => {
            dispatch({ type: types.PRAYER_WALL_TAB_CHANGED, activeTab });
            logUI('MBHWeb.PrayerWall.' + types.PRAYER_WALL_TAB_CHANGED, new Date(), tools.getURLPath(), { activeTab }, memberId);
        },
        getAllPrayers: callback => dispatch({ type: types.GET_ALL_PRAYERS, callback }),
        getMyPrayers: (memberId, callback) => dispatch({ type: types.GET_MY_PRAYERS, memberId, callback }),
        updateAllPrayers: (prayers, livePrayers, sessionStartTime, callback) =>
            dispatch({ type: types.GET_ALL_PRAYERS_SUCCESS, allPrayers: prayers, livePrayers, sessionStartTime, callback }),
        updateMyPrayers: (prayers, livePrayers) => dispatch({ type: types.GET_MY_PRAYERS_SUCCESS, myPrayersCount: prayers ? prayers.length : 0, prayers, livePrayers }),
        refreshAllPrayers: () => dispatch({ type: types.REFRESH_ALL_PRAYERS }),
        refreshMyPrayers: () => dispatch({ type: types.REFRESH_MY_PRAYERS }),
        getNextPrayers: callback => dispatch({ type: types.GET_NEXT_PRAYERS, callback }),
        getNotificationBadge: () => dispatch({ type: types.GET_NOTIFICATION_BADGE }),
        markNotificationBadgeAsRead: () => dispatch({ type: types.POST_NOTIFICATION_BADGE_ASREAD }),
        updatePreference: (PreferenceName, PreferenceValue) => dispatch({ type: types.UPDATE_USER_PREFERENCE, PreferenceName, PreferenceValue }),
        onEnteringPrayerWall: timestamp => dispatch({ type: types.PRAYER_WALL_ENTERED, timestamp }),
        onLeavingPrayerWall: sessionDurationInMinutes => dispatch({ type: types.PRAYER_WALL_LEFT, sessionDurationInMinutes }),
        getDeletedPosts: (callback) => dispatch({ type: types.GET_DELETED_POSTS, callback }),
        markDeletedPostsAsRead: () => dispatch({ type: types.MARK_DELETED_POST_ASREAD })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrayerWall);